import React from "react";
import {
  endInteraction,
  setcontactlist,
} from "../../../../Redux/Actions/actions";
import { connect } from "react-redux";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
  Box,
} from "@mui/material";

const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    externalChatData: state.data.externalChatData,
  };
};

const VoiceViewmodal = ({
  showVoicePreviewModal,
  recorderVoice,
  handleClose,
  sendMessage,
}) => {
  return (
    <Dialog
      open={showVoicePreviewModal}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        variant="subtitle2"
        sx={{ fontSize: "14px", fontWeight: 600, boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px" }}
      >
        Voice Preview
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Box
            className="mt-3"
            sx={{ display: "flex", justifyContent: "center", gap: 2 }}
          >
            {recorderVoice && <audio controls src={recorderVoice}></audio>}
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="outlined"
          onClick={() => {
            handleClose();
          }}
          size="small"
          disableElevation
          color="error"
          autoFocus
        >
          Close
        </Button>
        <Button
          sx={{ textTransform: "capitalize !important" }}
          variant="contained"
          onClick={sendMessage}
          size="small"
          disableElevation
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default connect(mapStateToProps, {
  endInteraction,
  setcontactlist,
})(VoiceViewmodal);
